import { render } from "./offcanvas-header.vue?vue&type=template&id=76592990"
import script from "./offcanvas-header.vue?vue&type=script&lang=js"
export * from "./offcanvas-header.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__